export type RvmStatus = 'open' | 'temporary_closed' | 'not_public' | 'members_only'

export interface RvmMachine {
  machineId: string
  name: string
  address: string
  districtCode: string
  latitude: number
  longitude: number
  machineType: string
  status: RvmStatus
  businessHour: string
  info: string
}

export const rvmMachines: RvmMachine[] = [
  {
    "machineId": "DF3003",
    "name": "黃埔天地",
    "address": "九龍黃埔船景街10號黃埔花園6期(黃埔號船尾)",
    "districtCode": "KLW",
    "latitude": 22.3040974,
    "longitude": 114.1899263,
    "machineType": "只供滴滴賞會員使用",
    "status": "members_only",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "[分分有禮﹒滴滴賞]會員可透過回收膠樽/鋁罐賺取環保分換取獎賞及AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF3002",
    "name": "香港逸東酒店",
    "address": "九龍彌敦道380號香港逸東酒店地下停車場",
    "districtCode": "KLW",
    "latitude": 22.3081897,
    "longitude": 114.171753,
    "machineType": "只供滴滴賞會員使用",
    "status": "members_only",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "[分分有禮﹒滴滴賞]會員可透過回收膠樽/鋁罐賺取環保分換取獎賞"
  },
  {
    "machineId": "DF2054",
    "name": "美林商場",
    "address": "新界沙田大圍美田路30號美林商場1樓近F2號舖",
    "districtCode": "NT",
    "latitude": 22.3782,
    "longitude": 114.1762388,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上6時正至晚上11時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2053",
    "name": "廣福商場",
    "address": "新界大埔廣福商場P層(近P104號舖)",
    "districtCode": "NT",
    "latitude": 22.4490766,
    "longitude": 114.1741779,
    "machineType": "不對外開放",
    "status": "not_public",
    "businessHour": "星期一至日及公眾假期︰早上6時正至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2052",
    "name": "翠屏南停車場",
    "address": "九龍觀塘翠屏道19號翠屏南邨停車場地下公共區域",
    "districtCode": "KLW",
    "latitude": 22.313051,
    "longitude": 114.2306972,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2051",
    "name": "翠屏(北)商場",
    "address": "九龍觀塘翠屏道19號翠屏(北)商場M2層(近123號舖)",
    "districtCode": "KLW",
    "latitude": 22.3155701,
    "longitude": 114.229836,
    "machineType": "暫停服務",
    "status": "temporary_closed",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2050",
    "name": "順利商場",
    "address": "九龍觀塘利安道15號順利商場3樓順豐自助櫃旁",
    "districtCode": "KLW",
    "latitude": 22.3313384,
    "longitude": 114.2259879,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2049",
    "name": "耀東商場",
    "address": "香港筲箕灣耀興道12號耀東商場地下卸貨區旁",
    "districtCode": "HK",
    "latitude": 22.2774422,
    "longitude": 114.2242321,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2048",
    "name": "愛東停車場",
    "address": "香港筲箕灣愛賢街18號愛東商場停車場地下4號電梯旁",
    "districtCode": "HK",
    "latitude": 22.2806533,
    "longitude": 114.2268812,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2047",
    "name": "逸東商場",
    "address": "新界東涌逸東商場2期地下",
    "districtCode": "NT",
    "latitude": 22.2818437,
    "longitude": 113.9349002,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2046",
    "name": "和記電訊大廈",
    "address": "新界青衣長輝路99號和記電訊大廈地下",
    "districtCode": "NT",
    "latitude": 22.3445678,
    "longitude": 114.1119016,
    "machineType": "暫停服務",
    "status": "temporary_closed",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2045",
    "name": "秀茂坪商場",
    "address": "九龍觀塘秀茂坪秀明道101號秀茂坪商場地下街市入口通道旁",
    "districtCode": "KLW",
    "latitude": 22.3196865,
    "longitude": 114.231959,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2044",
    "name": "瀝源廣場",
    "address": "新界沙田瀝源街6號瀝源廣場1樓女廁旁",
    "districtCode": "NT",
    "latitude": 22.3847165,
    "longitude": 114.1911815,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2043",
    "name": "企業廣場3期",
    "address": "九龍九龍灣宏照道39號企業廣場三期",
    "districtCode": "KLW",
    "latitude": 22.3204978,
    "longitude": 114.2094112,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上8時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2042",
    "name": "企業廣場2期",
    "address": "九龍灣常悅道3號企業廣場二期一樓 (1樓扶手電梯旁)",
    "districtCode": "KLW",
    "latitude": 22.3227286,
    "longitude": 114.2073422,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上8時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2041",
    "name": "企業廣場",
    "address": "九龍九龍灣 常悅道9號企業廣場1樓(扶手電梯旁)",
    "districtCode": "KLW",
    "latitude": 22.3227607,
    "longitude": 114.2079949,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上8時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2040",
    "name": "屯門時代廣場",
    "address": "新界屯門屯合街2號屯門時代廣場南翼第三層",
    "districtCode": "NT",
    "latitude": 22.3933129,
    "longitude": 113.9757905,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2039",
    "name": "愉景新城2 (Fusion)",
    "address": "新界荃灣青山公路荃灣段398號愉景新城1樓1033-34b及1069號舖 Fusion 內",
    "districtCode": "NT",
    "latitude": 22.384141,
    "longitude": 114.1140824,
    "machineType": "暫停服務",
    "status": "temporary_closed",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2038",
    "name": "沙田中心",
    "address": "新界沙田橫壆街2-16號沙田中心地下(扶手電梯旁)",
    "districtCode": "NT",
    "latitude": 22.3823979,
    "longitude": 114.1906079,
    "machineType": "不對外開放",
    "status": "not_public",
    "businessHour": "星期一至日及公眾假期︰早上6時正至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2037",
    "name": "迎海薈",
    "address": "新界馬鞍山烏溪沙路8號迎海薈地下5A號舖對出",
    "districtCode": "NT",
    "latitude": 22.4302265,
    "longitude": 114.2431986,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上6時正至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2036",
    "name": "友邦廣場",
    "address": "香港北角電氣道183號友邦廣場地下",
    "districtCode": "HK",
    "latitude": 22.2890752,
    "longitude": 114.192643,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2035",
    "name": "中文大學 (Fusion)",
    "address": "新界沙田香港中文大學富爾敦樓低層地下Fusion內",
    "districtCode": "NT",
    "latitude": 22.4184589,
    "longitude": 114.2047961,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日︰早上8時30分至晚上10時正 公眾假期︰早上8時30分至晚上9時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2034",
    "name": "香港教育大學",
    "address": "新界大埔露屏路10號香港教育大學B2座",
    "districtCode": "NT",
    "latitude": 22.4671177,
    "longitude": 114.1935903,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2033",
    "name": "奧海城三期",
    "address": "九龍大角咀海泓道1號奧海城3期地下(Shop G17對出)",
    "districtCode": "KLW",
    "latitude": 22.3177272,
    "longitude": 114.1647135,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上6時正至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2032",
    "name": "黃埔花園12期  (Taste)",
    "address": "九龍紅磡黃埔花園第十二期家居庭地庫B2號舖Taste內",
    "districtCode": "KLW",
    "latitude": 22.3056726,
    "longitude": 114.1908174,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2031",
    "name": "三聖商場",
    "address": "新界屯門三聖街6號三聖商場1樓近1號舖",
    "districtCode": "NT",
    "latitude": 22.3816479,
    "longitude": 113.9778398,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2030",
    "name": "長江中心 (Food Le Parc)",
    "address": "香港中環長江中心地下入口、地庫L1A層(部分)及地庫L2層(部分)舖Food Le Parc內",
    "districtCode": "HK",
    "latitude": 22.2794879,
    "longitude": 114.1603121,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上9時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2029",
    "name": "陽明山莊",
    "address": "香港大潭水塘道88號陽明山莊 (停車場內)",
    "districtCode": "HK",
    "latitude": 22.2575763,
    "longitude": 114.1994832,
    "machineType": "不對外開放",
    "status": "not_public",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2028",
    "name": "春暉道 (Fusion)",
    "address": "香港半山區渣甸山春暉道9號地下Fusion內",
    "districtCode": "HK",
    "latitude": 22.2774539,
    "longitude": 114.1916564,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2027",
    "name": "華蘭中心 (Food Le Parc)",
    "address": "香港鰂魚涌華蘭路華蘭中心地下1-3號鋪Food le Parc內",
    "districtCode": "HK",
    "latitude": 22.2869786,
    "longitude": 114.2133476,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上9時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2026",
    "name": "置富嘉湖(百佳超級市場)",
    "address": "新界天水圍天恩路12-18號+WOO嘉湖一期2樓 220號舖百佳超級廣場內",
    "districtCode": "NT",
    "latitude": 22.4577766,
    "longitude": 114.0025913,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2025",
    "name": "置富嘉湖2期",
    "address": "新界天水圍天恩路12號嘉湖商場二期",
    "districtCode": "NT",
    "latitude": 22.4575783,
    "longitude": 114.0043168,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2024",
    "name": "置富嘉湖1期",
    "address": "新界天水圍天恩路12號嘉湖商場一期2樓（近扶手梯）",
    "districtCode": "NT",
    "latitude": 22.4577553,
    "longitude": 114.0027651,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2023",
    "name": "映灣薈",
    "address": "新界東涌健東路1號映灣園映灣薈平台1樓近29-30號舖(近McDonald)",
    "districtCode": "NT",
    "latitude": 22.2920187,
    "longitude": 113.9492321,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上6時30分至晚上11時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2022",
    "name": "東薈城 (Taste)",
    "address": "新界東涌達東路20號東薈城B1-B10號鋪百佳超級市場內",
    "districtCode": "NT",
    "latitude": 22.289857,
    "longitude": 113.9405642,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2021",
    "name": "都會駅",
    "address": "新界將軍澳景嶺路8號都會駅3樓 (近003舖)",
    "districtCode": "NT",
    "latitude": 22.3051811,
    "longitude": 114.2518691,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2020",
    "name": "麗城薈",
    "address": "新界荃灣青山公路625號麗城薈3期地下（近16號舖",
    "districtCode": "NT",
    "latitude": 22.3721225,
    "longitude": 114.1020137,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上6時至晚上12時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2019",
    "name": "荃薈",
    "address": "新界荃灣德士古道36-60號荃薈商場地下 (近客戶服務中心)",
    "districtCode": "NT",
    "latitude": 22.3692206,
    "longitude": 114.1222677,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2018",
    "name": "置富第一城(2)",
    "address": "新界沙田沙田第一城銀城街1號置富第一城地下(近G36舖)",
    "districtCode": "NT",
    "latitude": 22.3869841,
    "longitude": 114.20426,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2017",
    "name": "第一城 (百佳超級市場)",
    "address": "新界沙田銀城街2號置富第一城‧樂薈地下7B, 46-80號百佳超級廣場內",
    "districtCode": "NT",
    "latitude": 22.3874582,
    "longitude": 114.2028306,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上7時30分至晚上10時30分",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2016",
    "name": "置富第一城(1)",
    "address": "新界沙田第一城長城街1號置富第一城地下G90-G91舖對出(匯豐銀行對出)",
    "districtCode": "NT",
    "latitude": 22.3873749,
    "longitude": 114.202797,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2015",
    "name": "大元商場",
    "address": "新界大埔區大埔大元商場地下LK01順豐自助櫃旁",
    "districtCode": "NT",
    "latitude": 22.4541029,
    "longitude": 114.1680188,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2014",
    "name": "啟田商場",
    "address": "九龍觀塘藍田啟田道50號啟田B停車場1樓 (繳費處對出)",
    "districtCode": "KLW",
    "latitude": 22.3084555,
    "longitude": 114.2351488,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2013",
    "name": "富亨商場",
    "address": "新界大埔頌雅路6號富亨商場地下(巴士休息亭對出)",
    "districtCode": "NT",
    "latitude": 22.4586661,
    "longitude": 114.1717778,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2012",
    "name": "隆亨商場",
    "address": "新界沙田大圍隆亨商場2樓近201號舖(近大快活)",
    "districtCode": "NT",
    "latitude": 22.3683311,
    "longitude": 114.1796087,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2011",
    "name": "海聯廣場住宅平台",
    "address": "新界粉嶺和睦路9號海聯廣場住宅平台會所 (只供住戶使用)",
    "districtCode": "NT",
    "latitude": 22.5004556,
    "longitude": 114.1416938,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2010",
    "name": "馬鞍山廣場",
    "address": "新界沙田馬鞍山西沙路608號馬鞍山廣場地下觀光升降機大堂",
    "districtCode": "NT",
    "latitude": 22.4256147,
    "longitude": 114.2313934,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2009",
    "name": "麗港城商場",
    "address": "九龍觀塘茶果嶺道88號麗港城商場地庫1樓 (近B05-07, B14-15號舖)",
    "districtCode": "KLW",
    "latitude": 22.3070203,
    "longitude": 114.2282908,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2008",
    "name": "又一城",
    "address": "九龍九龍塘達之路80號又一城LG2有蓋行人道",
    "districtCode": "KLW",
    "latitude": 22.3377578,
    "longitude": 114.174484,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2007",
    "name": "T.O.P",
    "address": "九龍旺角彌敦道700號4樓",
    "districtCode": "KLW",
    "latitude": 22.32064,
    "longitude": 114.169481,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上11時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2006",
    "name": "置富都會",
    "address": "九龍紅磡都會道6號置富都會7樓 (近751號舖則)",
    "districtCode": "KLW",
    "latitude": 22.3028933,
    "longitude": 114.1829762,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上9時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2005",
    "name": "沙角商場",
    "address": "新界沙田沙角街5號沙角商場2樓近39號舖(近中國銀行)",
    "districtCode": "NT",
    "latitude": 22.3864027,
    "longitude": 114.2036982,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2004",
    "name": "黃大仙中心北館",
    "address": "九龍黃大仙龍翔道136號黃大仙中心北館地下(跨境巴士櫃枱後方)",
    "districtCode": "KLW",
    "latitude": 22.342129,
    "longitude": 114.192374,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上7時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2003",
    "name": "TKO Gateway",
    "address": "新界西貢及將軍澳常寧路厚德邨TKO Gateway東翼地下 (在街市入口對開位置)",
    "districtCode": "NT",
    "latitude": 22.316962,
    "longitude": 114.266253,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上9時至晚上10時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF2002",
    "name": "樂富廣場",
    "address": "九龍橫頭磡聯合道198號樂富廣場A區1樓1111號舖對出 (7-11對出)",
    "districtCode": "KLW",
    "latitude": 22.3373748,
    "longitude": 114.1873131,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰24 小時開放",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF0001",
    "name": "中華煤氣有限公司",
    "address": "香港北角渣華道363號 11樓 (只供員工使用)",
    "districtCode": "NT",
    "latitude": 22.291502,
    "longitude": 114.2096217,
    "machineType": "只供滴滴賞會員使用",
    "status": "members_only",
    "businessHour": "星期一至日︰早上9時至晚上5時正 公眾假期︰休息",
    "info": "[分分有禮﹒滴滴賞]會員可透過回收膠樽/鋁罐賺取環保分換取獎賞及AlipayHK現金儲值額回贈"
  },
  {
    "machineId": "DF0000",
    "name": "海濱匯",
    "address": "九龍觀塘海濱道77號海濱匯3樓平台花園",
    "districtCode": "KLW",
    "latitude": 22.3167221,
    "longitude": 114.2136333,
    "machineType": "可供公眾使用",
    "status": "open",
    "businessHour": "星期一至日及公眾假期︰早上8時至晚上8時正",
    "info": "使用者可透過回收膠樽/鋁罐賺取AlipayHK現金儲值額回贈"
  }
]
